import { render, staticRenderFns } from "./InvoiceYearSelect.vue?vue&type=template&id=43d99d24&scoped=true&"
import script from "./InvoiceYearSelect.vue?vue&type=script&lang=js&"
export * from "./InvoiceYearSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d99d24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
